<template>
  <div>
    <el-table :data="ballot">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="purchaseId" label="项目ID"></el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="payAmount" label="金额"></el-table-column>
      <el-table-column label="签号">
        <template slot-scope="scope">
          <span v-if="!scope.row.minBallotNum">暂无</span>
          <span v-else-if="scope.row.minBallotNum && scope.row.maxBallotNum"
            >{{ scope.row.minBallotNum }}-{{ scope.row.maxBallotNum }}</span
          >
          <span v-else-if="scope.row.minBallotNum && !scope.row.maxBallotNum">{{
            scope.row.minBallotNum
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tallAmount" label="总签数"></el-table-column>
      <el-table-column prop="gitAmount" label="中签数"></el-table-column>
      <el-table-column label="抽奖状态">
        <template slot-scope="scope">
          <span v-if="scope.row.gitStatus == 0">未抽奖</span>
          <span v-else-if="scope.row.gitStatus == 1">抽奖中</span>
          <span v-else-if="scope.row.gitStatus == 2">抽奖成功</span>
          <span v-else>抽奖失败</span>
        </template>
      </el-table-column>
      <el-table-column label="支付状态">
        <template slot-scope="scope">
          <span v-if="scope.row.payStatus == 1">支付成功</span>
          <span v-else-if="scope.row.payStatus == 2">支付失败</span>
          <span v-else-if="scope.row.payStatus == 3">支付超时</span>
          <span v-else>未支付</span>
        </template>
      </el-table-column>
      <el-table-column label="解冻状态">
        <template slot-scope="scope">
          <span v-if="scope.row.returnStatus == 1">解冻成功</span>
          <span v-else-if="scope.row.returnStatus == 2">解冻失败</span>
          <span v-else-if="scope.row.returnStatus == 3">解冻超时</span>
          <span v-else>未解冻</span>
        </template>
      </el-table-column>
      <el-table-column label="发币状态">
        <template slot-scope="scope">
          <span v-if="scope.row.sendStatus == 1">发币成功</span>
          <span v-else-if="scope.row.sendStatus == 2">发币失败</span>
          <span v-else-if="scope.row.sendStatus == 3">发币超时</span>
          <span v-else>未发币</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'discountList',
  data() {
    return {};
  },
  components: {
    Pagination
  },
  computed: {
    ...mapState('discountrecord', ['ballot', 'pagination', 'totalCount'])
  },
  methods: {
    ...mapActions('discountrecord', ['getaward']),
    ...mapMutations('discountrecord', ['setPagination']),
    handleCurrentChange(pagination) {
      this.setPagination(pagination);
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less"></style>
